import { PermissionDto } from "@merchant_api/models/permission-dto";
import { RoleDetailsDto } from "@merchant_api/models/role-details-dto";

export class RoleState {
    loading = false;
    error = null;
    role: RoleDetailsDto = null;
    permissionList: PermissionDto[] = null;
}
